import { render } from "./DashboardAdmin.vue?vue&type=template&id=c99ddda6&scoped=true"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js"

import "./DashboardAdmin.vue?vue&type=style&index=0&id=c99ddda6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c99ddda6"]])

export default __exports__